import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type Query = {
  condition: string;
  field: string;
  value: string;
  string: string;
};

interface SliceState {
  filters: Query[];
  query: Query;
  queryString: string;
  page: number;
  isSearch: boolean;
}

const initialState: SliceState = {
  filters: [],
  query: {
    condition: 'is',
    field: '',
    value: '',
    string: '',
  },
  queryString: '',
  page: 1,
  isSearch: false,
};

export const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    addFilter: (state, action) => {
      const { query } = action.payload;
      const filters = state.filters ?? [];
      const existingIndex = filters.findIndex(item => item.field === query.field);

      if (existingIndex !== -1) {
        filters[existingIndex] = query;
      } else {
        filters.push(query);
      }

      state.filters = filters;
      state.queryString = filters.map(f => f.string).join('&');
    },
    removeFilter: (state, actions) => {
      let queryString = '';
      const filters = state.filters?.filter(
        (item) => item.field !== actions.payload
      );

      for (let i = 0; i < filters.length; i++) {
        queryString = queryString.concat('&', filters[i].string);
      }

      state.queryString = queryString;
      state.filters = filters;
    },
    setValue: (state, action) => {
      const newQuery = {
        ...state.query,
        value: action.payload.query.value,
      };
      state.query = newQuery;
    },
    resetFilter: (state) => {
      state.filters = [];
      state.query = {
        value: '',
        condition: '',
        string: '',
        field: '',
      };
      state.queryString = '';
      state.page = 1;
    },
    changeFlowbuilderPage: (
      state,
      actions: PayloadAction<{ isSearch: boolean; action?: number }>
    ) => {
      const { action, isSearch } = actions.payload;

      if (isSearch) {
        state.isSearch = true;
      } else {
        state.page = action;
        state.isSearch = false;
      }
    },
  },
});

export const {
  addFilter,
  removeFilter,
  setValue,
  resetFilter,
  changeFlowbuilderPage,
} = filterSlice.actions;
